import { render, staticRenderFns } from "./InactiveDialog.vue?vue&type=template&id=6ec63d0f&"
import script from "./InactiveDialog.vue?vue&type=script&lang=js&"
export * from "./InactiveDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports